import React from 'react';
import { skills } from '../helpers/data';
import SkillCard from './SkillCard';

function Skills() {
  return (
    <div className="p-4 xl:p-8 sm:mx-8 md:mx-10 sm:pt-10 h-screen flex flex-col justify-center">
      <h1 className="text-lightGreen font-bold text-2xl xl:text-4xl lg:text-3xl mb-2 md:my-4 2xl:mb-7">Skills</h1>
      <p className="text-slate-100 sm:text-lg md:text-xl xl:text-2xl">The skills and technologies I use to bring your ideas to life:</p>
      <div className="p-1 mt-3 sm:mt-6 grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 xl:grid-cols-7 2xl:grid-cols-8 gap-4">
        {skills.map(({name, icon}) => <SkillCard key={ name } name={ name } icon={ icon }/>)}
      </div>
    </div>
  );
}

export default Skills;
